import axios from "axios";
import router from "@/router";
export default {
  state: {
    // hl_url: "https://bupeapidevelopment.azurewebsites.net/api/",
    hl_url: "https://bupewebprodapi.azurewebsites.net/api/",
    // hl_url: "https://happibanksbackend.helexiumdataia.com/api/", //ok

    // hl_url: "http://localhost:51429/api/",
    // hl_url: "https://localhost:44388/api/", //oknpm r
    // hl_url: "https://localhost:44388/api/", //oknpm r
    // hl_url: "http://127.0.0.1:44388/api/", //ok
    // hl_url: "http://127.0.0.1:44388/Api/", //ok
    // hl_url: "http://devbackend.helexiumfiles.com/api/", //ok
    // hl_url: "https://192.168.1.4:44388/Api/", //ok

    PersonaAct: {},
  },
  mutations: {
    setPersonaAct(state, data) {
      state.PersonaAct = data;
      ////console.log(state.PersonaAct.id);
      localStorage.setItem("setPersonaAct", JSON.stringify(state.PersonaAct));
      //  let res = await this.$store.getters.fetchGet( {
      //  path: "Persona/GetPersonaById/" + this.PersonaId,
      //   });
      //  this.Persona = await res.json();
    },

    setData(state, data) {
      state.data = data;
    },
    setToken(state, token) {
      localStorage.setItem("tk", token);
      state.token = token;
    },
  },
  actions: {
    // #region LOGIN
    async hl_loginPersona(context, { data }) {
      try {
        //data = data JSON.stringify({Usuario:"administrador@helexium.com", contrasena:"Bupe3108/"})
        // data = JSON.stringify({Usuario:"admindemo@testing.com", contrasena:"12345"})
        ////console.log(data)
        const options = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: data,
        };
        let res = await fetch(
          context.state.hl_url + "Authentication/LoginPersona",
          options
        );
        let tokenres = await fetch(
          context.state.hl_url + "Authentication/GetToken",
          options
        );
        ////console.log(res)
        let result = await res.json();
        delete result.contrasena;
        delete result.contrasenaReportes;
        delete result.contrasenaIframe;
        tokenres = await tokenres.json();
        this.commit("setToken", tokenres.token);
        this.commit("setPersonaAct", result);
        if (res.error) {
          //this.$swal({title:"Aviso", text:"Datos almacenados correctamente", icon:"success"})
          alert(res.error);
          return;
        } else {
          return result;
        }
      } catch (error) {
        console.error("error", error);
        return {};
      }
    },
    async hl_login(context, { data }) {
      try {
        //data = data JSON.stringify({Usuario:"administrador@helexium.com", contrasena:"Bupe3108/"})
        // data = JSON.stringify({Usuario:"admindemo@testing.com", contrasena:"12345"})
        ////console.log(data)
        const options = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: data,
        };
        let res = await fetch(
          context.state.hl_url + "Authentication/LoginPersonaV1",
          options
        );
        let tokenres = await fetch(
          context.state.hl_url + "Authentication/GetTokenV1",
          options
        );
        ////console.log(res)
        let result = await res.json();
        delete result.contrasena;
        delete result.contrasenaReportes;
        delete result.contrasenaIframe;
        tokenres = await tokenres.json();
        this.commit("setToken", tokenres.token);
        this.commit("setPersonaAct", result);
        if (res.error) {
          //this.$swal({title:"Aviso", text:"Datos almacenados correctamente", icon:"success"})
          alert(res.error);
          return;
        } else {
          return result;
        }
      } catch (error) {
        console.error("error", error);
        return {};
      }
    },
    // #endregion
    // #region GET
    async hl_get(context, { path }) {
      try {
        let token = localStorage.getItem("tk");
        const options = {
          method: "GET",
          headers: {
            Authorization: "Bearer " + token,
          },
        };
        let res = await fetch(context.state.hl_url + path, options);
        if (res.status == 401) {
          console.log("Sin autorización, cerrando sesión: ", res.status);
          //return router.push("/");
        }
        let req = await res.json(); // await JSON.parse(res)
        if (res.mensaje == "Token inválida") {
          //router.push('/')
        }
        if (res.error) {
          console.error(res.error);
          alert(res.mensaje);
        } else {
          return req;
        }
      } catch (error) {
        console.error("error", error);
        return error;
      }
    },
    async hl_get_file(context, { path, responseType = "json" }) {
      try {
        let token = localStorage.getItem("tk");
        const options = {
          method: "GET",
          headers: {
            Authorization: "Bearer " + token,
          },
        };

        // Realizamos la solicitud
        let res = await fetch(context.state.hl_url + path, options);

        // Procesar la respuesta según el tipo de dato esperado
        let req;
        if (responseType === "blob") {
          req = await res.blob(); // Procesamos la respuesta como un Blob
        } else if (responseType === "json") {
          req = await res.json(); // Procesamos la respuesta como JSON
        } else {
          throw new Error("Tipo de respuesta no soportado");
        }

        // Verificar posibles errores en la respuesta
        if (res.status === 401) {
          // Token inválido, redirigir o manejar de otra manera
          console.error("Token inválido");
          // router.push('/');
        }

        if (res.error) {
          console.error(res.error);
          alert(res.mensaje);
        } else {
          return req;
        }
      } catch (error) {
        console.error("error", error);
        return error;
      }
    },
    async hl_get_cookie(context, { path }) {
      try {
        let token = localStorage.getItem("tk");
        const options = {
          method: "GET",
          credentials: "include",
          headers: {
            Authorization: "Bearer " + token,
          },
        };
        let res = await fetch(context.state.hl_url + path, options);
        if (res.status == 401) {
          console.log("Sin autorización, cerrando sesión: ", res.status);
          return router.push("/");
        }
        let req = await res.json(); // await JSON.parse(res)
        if (res.mensaje == "Token inválida") {
          //router.push('/')
        }
        if (res.error) {
          console.error(res.error);
          alert(res.mensaje);
        } else {
          return req;
        }
      } catch (error) {
        console.error("error", error);
        return error;
      }
    },
    async hl_get_file_cookie(context, { path, responseType = "json" }) {
      try {
        let token = localStorage.getItem("tk");
        const options = {
          method: "GET",
          credentials: "include",
          headers: {
            Authorization: "Bearer " + token,
          },
        };

        // Realizamos la solicitud
        let res = await fetch(context.state.hl_url + path, options);

        // Procesar la respuesta según el tipo de dato esperado
        let req;
        if (responseType === "blob") {
          req = await res.blob(); // Procesamos la respuesta como un Blob
        } else if (responseType === "json") {
          req = await res.json(); // Procesamos la respuesta como JSON
        } else {
          throw new Error("Tipo de respuesta no soportado");
        }

        // Verificar posibles errores en la respuesta
        if (res.status === 401) {
          // Token inválido, redirigir o manejar de otra manera
          console.error("Token inválido");
          // router.push('/');
        }

        if (res.error) {
          console.error(res.error);
          alert(res.mensaje);
        } else {
          return req;
        }
      } catch (error) {
        console.error("error", error);
        return error;
      }
    },

    // #endregion

    // #region POST

    async hl_post(context, { path, data }) {
      try {
        let token = localStorage.getItem("tk");
        const options = {
          method: "post",
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        };
        let req = await fetch(context.state.hl_url + path, options);
        let res = await req.json();
        if (res.mensaje == "Token inválida") {
          //router.push('/')
        }
        if (res.error) {
          alert(res.error);
        } else {
          return res;
        }
      } catch (error) {
        console.error("error---------->", error);
        return error;
      }
    },
    async hl_post_cookie(context, { path, data }) {
      try {
        let token = localStorage.getItem("tk");
        const options = {
          method: "post",
          credentials: "include",
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        };
        let req = await fetch(context.state.hl_url + path, options);
        let res = await req.json();
        if (res.mensaje == "Token inválida") {
          //router.push('/')
        }
        if (res.error) {
          alert(res.error);
        } else {
          return res;
        }
      } catch (error) {
        console.error("error---------->", error);
        return error;
      }
    },
    async hl_post_file(context, { path, data }) {
      try {
        let token = localStorage.getItem("tk");

        const options = {
          method: "post",
          headers: {
            Authorization: "Bearer " + token,
            // No establezcas manualmente 'Content-Type', fetch lo hará automáticamente
          },
          body: data,
        };

        let req = await fetch(context.state.hl_url + path, options);
        let res = await req;

        if (res.mensaje == "Token inválida") {
          // router.push('/');
        }

        if (res.error) {
          alert(res.error);
        } else {
          return res;
        }
      } catch (error) {
        console.error("error---------->", error);
        return error;
      }
    },
    async hl_post_file_axios(context, { path, data, onProgress }) {
      try {
        let token = localStorage.getItem("tk");

        const tipoArchivo = data.get("fileType");
        if (!tipoArchivo) {
          return {
            respuesta: false,
            mensaje: "No se ha adjuntado ningún archivo.",
          };
        }

        const allowedTypes = [
          // Imágenes
          "image/jpeg",
          "image/png",
          "image/jpg",
          "image/webp",
          "image/gif",
          "image/bmp",
          "image/tiff",
          // Documentos
          "application/pdf",
          "application/msword", // .doc
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
          "application/vnd.ms-excel", // .xls
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
          // Videos
          "video/mp4",
          "video/avi",
          "video/mpeg",
          "video/quicktime",
          "video/x-msvideo",
          "video/x-matroska",
        ];
        console.log(
          `[hl_post_file_axios] el tipo de archivo es: ${tipoArchivo}`
        );

        if (!allowedTypes.includes(tipoArchivo.trim())) {
          return {
            respuesta: false,
            mensaje: `El tipo de archivo "${tipoArchivo.trim() || "desconocido"
              }" no está permitido. 
        Solo se aceptan imágenes, documentos PDF/Word/Excel o videos.`,
          };
        }

        const response = await axios.post(context.state.hl_url + path, data, {
          headers: {
            Authorization: "Bearer " + token,
          },
          onUploadProgress: (progressEvent) => {
            if (
              progressEvent.lengthComputable &&
              typeof onProgress === "function"
            ) {
              const percent = Math.round(
                (progressEvent.loaded / progressEvent.total) * 100
              );
              onProgress(percent);
            }
          },
        });

        const res = response.data;

        if (res.mensaje === "Token inválida") {
          // router.push('/');
          return {
            respuesta: false,
            mensaje: "Sesión expirada. Inicia sesión nuevamente.",
          };
        }

        if (res.error) {
          console.error("Error del servidor:", res.error);
          return { respuesta: false, mensaje: res.error };
        }

        return res;
      } catch (error) {
        console.error("Error de carga:", error);
        return {
          respuesta: false,
          mensaje: `Error al subir archivo: ${error.message || "Error desconocido"
            }`,
        };
      }
    },

    async hl_post_excelReport(context, { path, data }) {
      try {
        const token = localStorage.getItem("tk");
        const options = {
          method: "POST",
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        };

        const response = await fetch(context.state.hl_url + path, options);

        if (!response.ok) {
          throw new Error(`Error en la solicitud: ${response.statusText}`);
        }

        const blob = await response.blob();

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        link.setAttribute(
          "download",
          `${data.nombreArchivo || "Reporte"}.xlsx`
        );
        document.body.appendChild(link);
        link.click();

        link.remove();

        console.log("Archivo descargado con éxito.");
      } catch (error) {
        console.error("Error en la solicitud POST:", error);
        return { error: error.message };
      }
    },

    async hl_post_file_cookie(context, { path, data }) {
      try {
        const token = localStorage.getItem("tk");

        // Construimos el FormData y agregamos el archivo
        const formData = new FormData();
        formData.append("archivo", data); // nombre debe coincidir con el del backend

        const options = {
          method: "POST",
          credentials: "include",
          headers: {
            Authorization: "Bearer " + token,
            // NO pongas 'Content-Type' cuando usas FormData
          },
          body: formData,
        };

        const response = await fetch(context.state.hl_url + path, options);

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`Error ${response.status}: ${errorText}`);
        }

        const result = await response.json();

        // Validaciones opcionales según tu estructura
        if (result.mensaje === "Token inválida") {
          // router.push('/');
        }

        if (result.error) {
          alert(result.error);
        }

        return result;
      } catch (error) {
        console.error("Error en hl_post_file_cookie:", error);
        return null;
      }
    },

    async onFileCustomDrive(context, { file, remoteFilePath, soloImagenes }) {
      try {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("remoteFilePath", remoteFilePath);
        formData.append("soloImagenes", soloImagenes);

        const token = localStorage.getItem("tk");
        const url = context.state.hl_url + "CargaMultimedia/UploadFileDrive";

        const options = {
          method: "POST",
          headers: {
            Authorization: "Bearer " + token,
          },
          body: formData,
        };

        const req = await fetch(url, options);

        if (req.ok) {
          const result = await req.json();
          console.log("Respuesta del servidor:", result);
          return result;
        } else {
          console.error("Error en la petición:", req.statusText);
          return { respuesta: false, mensaje: "Error al subir archivo" };
        }
      } catch (error) {
        console.error("error in onFileCustomDrive", error);
        return { respuesta: false, mensaje: error.message };
      }
    },

    // #endregion

    // #region PUT

    async hl_put_cookie(context, { path, data }) {
      try {
        let token = localStorage.getItem("tk");
        const options = {
          method: "PUT",
          credentials: "include",
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        };
        let req = await fetch(context.state.hl_url + path, options);
        let res = await req.json();
        if (res.mensaje === "Token inválida") {
          console.warn("Token inválido");
        }
        if (res.error) {
          alert(res.error);
        } else {
          return res;
        }
      } catch (error) {
        console.error("Error en la solicitud PUT:", error);
        return { error: error.message };
      }
    },

    async hl_put(context, { path, data }) {
      try {
        let token = localStorage.getItem("tk");
        const options = {
          method: "PUT",
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        };
        let req = await fetch(context.state.hl_url + path, options);
        let res = await req.json();
        if (res.mensaje === "Token inválida") {
          console.warn("Token inválido");
        }
        if (res.error) {
          alert(res.error);
        } else {
          return res;
        }
      } catch (error) {
        console.error("Error en la solicitud PUT:", error);
        return { error: error.message };
      }
    },

    // #endregion

    // #region DELETE
    async hl_delete(context, { path, data }) {
      try {
        let token = localStorage.getItem("tk");
        const options = {
          method: "delete",
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        };
        let req = await fetch(context.state.hl_url + path, options);
        let res = await req.json();
        if (res.mensaje == "Token inválida") {
          //router.push('/')
        }
        if (res.error) {
          alert(res.error);
        } else {
          return res;
        }
      } catch (error) {
        console.error("error---------->", error);
        return error;
      }
    },
    // #endregion

    // #region PATCH

    // ENDPOINT SIN BODY PARA LA SUPER TRANSPORTE
    async hl_patch_cookie(context, { path }) {
      try {
        let token = localStorage.getItem("tk");
        const options = {
          method: "PATCH",
          credentials: "include",
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          },
        };
        let req = await fetch(context.state.hl_url + path, options);
        let res = await req.json();
        if (res.mensaje === "Token inválida") {
          console.warn("Token inválido");
        }
        if (res.error) {
          alert(res.error);
        } else {
          return res;
        }
      } catch (error) {
        console.error("Error en la solicitud PATCH:", error);
        return { error: error.message };
      }
    },

    // #endregion
  },
  getters: {},
};
